import React from 'react';
import type { TierLevel } from '../../lib/types';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'gold' | 'tier';
  tier?: TierLevel;
  size?: 'sm' | 'md';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  tier,
  size = 'sm',
  className = ''
}: BadgeProps) {
  const tierStyles: Record<string, string> = {
    member: 'bg-[#666666]/20 text-[#999999] border-[#666666]/30',
    silver: 'bg-[#A0AEC0]/15 text-[#A0AEC0] border-[#A0AEC0]/30',
    gold: 'bg-[#C8A84E]/15 text-[#C8A84E] border-[#C8A84E]/30',
    vip: 'bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/30'
  };
  const variantStyles: Record<string, string> = {
    default: 'bg-[#2A2A2A] text-[#B0B0B0] border-[#333333]',
    success: 'bg-[#22C55E]/15 text-[#22C55E] border-[#22C55E]/30',
    warning: 'bg-[#F59E0B]/15 text-[#F59E0B] border-[#F59E0B]/30',
    error: 'bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/30',
    info: 'bg-[#3B82F6]/15 text-[#3B82F6] border-[#3B82F6]/30',
    gold: 'bg-[#C8A84E]/15 text-[#C8A84E] border-[#C8A84E]/30',
    tier: tier ? tierStyles[tier] : tierStyles.member
  };
  const sizes: Record<string, string> = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm'
  };
  return <span className={`inline-flex items-center font-medium rounded-full border ${variantStyles[variant]} ${sizes[size]} ${className}`} data-id="element-567">
      {children}
    </span>;
}